// MATCHHEIGHT JS
function MatchHeight() {}

jQuery( document ).ready(function() {
    setInterval(function() { 
      $(".product-card .product-card__heading").matchHeight();  
      $(".product-card .product-card__container .price").matchHeight();
    }, 1000);
});

$(window).on('load', function(){
  function MatchHeight() {
    $(".product-card .product-card__container .mt10").matchHeight();
    $(".chm-reviews .chm-reviews__heading").matchHeight();
    $(".chm-reviews .chm-reviews__description").matchHeight();
    $(".product-card .product-card__heading").matchHeight();  
    $(".product-card .product-card__container .price").matchHeight();
    $("product-recommendations .product-card .product-card__heading").matchHeight();  
    $("product-recommendations .product-card .product-card__container .price").matchHeight();    
    $(".blog-posts .blog-posts__heading").matchHeight();  
    $(".blog-posts .blog-posts__meta").matchHeight();
    $(".blog-posts .blog-posts__excerpt").matchHeight();
    $(".text-columns-icons").matchHeight();
  
    // $(".brands.top-spacing-normal .grid.slider .slider__slide .image-hover-scaling__image").matchHeight();
  } 
  window.setTimeout(MatchHeight(), 5000); 
});

const timeID = setInterval(matchheight2, 1000);
const timeID1 = setInterval(matchheight3, 1000);
function matchheight3() {
  if ($('#review_col1 .slick-prev').length > 0) {
    $('.progress').show();
  }else{
    $('.progress').hide();
  }
}
function matchheight2() {
  $(".template-collection .product-card .product-card__container .mt10").matchHeight();
  $(".template-collection .product-card .product-card__heading").matchHeight();
   $(".template-collection .product-card .product-card__container .price").matchHeight();
}
$(window).on("load", function () { 
 matchheight2();
 matchheight3();
});

$( "#post_filter" ).on( "click", function() {

    var $listSort = $('.disclosure__list');
    if ($listSort.attr('hidden')) {
        $listSort.attr('hidden', false);
    } else {
        $listSort.attr('hidden', true);
    }
});  

$(".list-menu").hover(function () {
      $(".col-3").removeClass("open");
      $(".unstyle-ul.megamenu-childs").removeClass("active");
});       
$(".col-3").hover(function () {
  $(".col-3").removeClass("open");
  $(".unstyle-ul.megamenu-childs").removeClass("active");
  $(this).closest(".col-3").addClass("open");
  $(this).find(".unstyle-ul").addClass("active");
});


 var $slider = $('#review_col1');
  var $progressBar = $('.progress');
  var $progressBarLabel = $( '.slider__label' );
  
  $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
    var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
    console.log(nextSlide);
    $progressBar
      .css('background-size', calc + '% 100%')
      .attr('aria-valuenow', calc );
    
    $progressBarLabel.text( calc + '% completed' );
  });

$('#review_col1').on('init', function(event, slick){
    console.log("initialized")
});

 $("#review_col1").slick({
    dots: false,
    customPaging: function(slider, i) { 
          return '<div class="slider__buttons__container"><div class="slider__button"></div></div>';
    }, 
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    // autoplay: true,
    // autoplaySpeed: 2500,
    arrows: true,
    prevArrow:'<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="20"; height="20" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg></button>',
    nextArrow:'<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="20"; height="20" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/></button>',
    responsive: [{
        breakpoint: 1200,
        settings: {
            slidesToShow: 3,
            slidesToScroll: 1
        }
    }, {
        breakpoint: 991,
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1
        }
    }, {
        breakpoint: 767,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }]
 }); 

 $("#feature_col1").slick({
  dots: false,
  customPaging: function(slider, i) { 
        return '<div class="slider__buttons__container"><div class="slider__button"></div></div>';
  }, 
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  arrows: false,
  prevArrow:'<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="20"; height="20" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg></button>',
  nextArrow:'<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="20"; height="20" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/></button>',
  responsive: [{
      breakpoint: 1024,
      settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
      }
  }, {
      breakpoint: 600,
      settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true
      }
  }, {
      breakpoint: 480,
      settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          dots: true
      }
  }]
});

$(document).on('click', function (e) {
    if ($(e.target).closest(".facet-filters__sort").length === 0) {
        $("#blog_post_ul").attr('hidden', true);   
    }
});

   $("#ContactForm-phone").keypress(function (e) {      
    var charCode = (e.which) ? e.which : event.keyCode    
    if (String.fromCharCode(charCode).match(/[^0-9]/g))    
        return false;                        
    }); 